import { React, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link, useLocation } from 'react-router-dom';
import { Layout, Menu, Select} from 'antd';

import {
  Card,
  Col,
  Row,
  Typography,
} from "antd";

import Echart from "./EChart.js";
import LineChart from "./LineChart.js";
import DoughnutChart from "./DoughnutChart.js";
import ScrollableTable from "./TableSummary.js";
import Sidebar from "../../Side_Bar/Admin_Side_Bar.js";

const { Sider, Content } = Layout;

const App = ({ children }) =>{
  const location = useLocation();
  const { Title, Text } = Typography;
  const [loading, setIsLoading] = useState(true);
  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";

  // const contractOptions = ["Blue Ice", "Far Tech", "IBPO"];
  const [contractOptions, setContractOptions] = useState([]);
  const [contractIds, setContractIds] = useState([]);
  const [selectedContract, setSelectedContract] = useState('');
  const [id, setId] = useState(-1);
  const [isContractDataLoaded, setIsContractDataLoaded] = useState(false);

  const [data, setData] = useState([]);
  const [unique_num, setUniqueNum] = useState([]);
  const [unique_sess, setUniqueSess] = useState([]);
  const [contract_data, setContractData] = useState([]);
  const [customer_pricing_data, setCustomerPricing] = useState([]);
  const [company_pricing_data, setCompanyPricing] = useState([]);

  useEffect(() => {
    const fetchContractData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getAllTable?tableName=Contract`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      } catch (error) {
        console.error('Error fetching table data:', error);
        // Handle error appropriately, e.g., set an error state
        throw error; // Re-throw the error for the calling function to handle
      }
    };
  
    const fetchContractDataAPI = async () => {
      try {
        const contractList = await fetchContractData();
  
        const contracts = contractList.map(contract => ({
          id: contract.contract_id,
          name: contract.name,
        }));
  
        setContractIds(contracts);
        setId(contracts[0].id);
  
        setSelectedContract(contracts[0].name);
        setContractOptions(contracts.map(contract => contract.name));
  
        setIsContractDataLoaded(true);
      } catch (error) {
        // Handle error, e.g., show an error message to the user
        console.error('Error fetching data:', error);
      }
    };
  
    // Call the asynchronous function directly within useEffect
    fetchContractDataAPI();
  }, []); // Empty dependency array to ensure the effect runs once on mount
  


  // Simulated fetch of customer data
  useEffect(() => {
    setIsLoading(true);
    // Function to fetch data from a given URL
    const fetchData = async (url) => {
      
      try {
        const response = await fetch(url);
        const data = await response.json();
        console.log(`Data from ${url}:`, data);
        return data;
      } catch (error) {
        console.error(`Error fetching data from ${url}:`, error);
        throw error;
      }
    };

    const fetchDataAPI = async () =>{
      if (id !== -1){
        console.log("ID is: ", id)
        const messagesUrl = `${mainUrl}/getTable?tableName=Message&contract_id=${id}`;
        const uniqueNumbersUrl = `${mainUrl}/getUniqueNumbersMonthly?contract_id=${id}`;
        const uniqueSessionsUrl = `${mainUrl}/getUniqueSessionsMonthly?contract_id=${id}`;
        const contractUrl = `${mainUrl}/getTable?tableName=Contract&contract_id=${id}`;
        const CustomerPricingRateUrl = `${mainUrl}/getTable?tableName=Customer_Pricing&contract_id=${id}`;
        const CompanyPricingRateUrl = `${mainUrl}/getTable?tableName=Company_Pricing&contract_id=${id}`;

        setData(await fetchData(messagesUrl));
        setUniqueNum(await fetchData(uniqueNumbersUrl));
        setUniqueSess(await fetchData(uniqueSessionsUrl));
        setContractData(await fetchData(contractUrl));
        setCustomerPricing(await fetchData(CustomerPricingRateUrl));
        setCompanyPricing(await fetchData(CompanyPricingRateUrl));

        setIsLoading(false);

      }else{
        console.log("ID is -1")
      }
        
    }
    fetchDataAPI();
    
  }, [id]);


  const handleDropdownChange = (value, selectedIndex) => {
    // Use selectedIndex as needed
    console.log("Selected Index:", selectedIndex);

    setId(contractIds[selectedIndex].id)

    // console.log(typeof contractIds[selectedIndex].id)
    // console.log(contractIds)

    // await fetchContractDataAPI();
    setSelectedContract(contractIds[selectedIndex].name);
  };
  
  let total_messages            = 0;
  let average_media_per_message = 0;
  let total_cost                = 0;
  let average_cost              = 0;
  let average_messages          = 0;
  let no_users                  = 0;
  let no_sessions               = 0;
  
  const cost_map = new Map();
  const no_messages = new Map();
  const users_map = new Map();
  const sessions_map = new Map();
  const unique_users_map = new Map();

  for (let i = 0; i<unique_sess.length; i++){
    sessions_map.set(unique_sess.at(i).month, unique_sess.at(i).num_sessions);
  }

  for (let i = 0; i<unique_num.length; i++){
    unique_users_map.set(unique_num.at(i).month, unique_num.at(i).unique_acc_from_count);
  }

  for(let i =0; i<data.length; i++){
    const year = data.at(i).date_sent.split("T")[0].split("-")[0];
    const month = data.at(i).date_sent.split("T")[0].split("-")[1];

    if(cost_map.get(year + "-" + month) == undefined){
      cost_map.set(year + "-" + month, data.at(i).company_cost);
    }else{
      cost_map.set(year + "-" + month , cost_map.get(year + "-" + month) + data.at(i).company_cost);
    }

    if(no_messages.get(year + "-" + month) == undefined){
      no_messages.set(year + "-" + month, 1);
    }else{
      no_messages.set(year + "-" + month, no_messages.get(year + "-" + month) + 1);
    }

    if(users_map.get(data.at(i).acc_from) == undefined){
      users_map.set(data.at(i).acc_from, 1);
    }else{
      users_map.set(data.at(i).acc_from, users_map.get(data.at(i).acc_from) + 1);
    }
    
    average_media_per_message += data.at(i).num_media;
    total_cost += data.at(i).company_cost;
  }
  
  cost_map.forEach((value, key) => {
    average_cost += value;
  });

  no_messages.forEach((value, key) => {
    total_messages += value;
  });

  users_map.forEach((value, key) => {
    no_users += 1;
  });

  sessions_map.forEach((value, key) => {
    no_sessions += value;
  });

  average_messages = total_messages/no_messages.size;
  average_media_per_message /= data.length;
  average_cost /= cost_map.size;

  average_media_per_message =average_media_per_message.toFixed(3);
  average_messages = average_messages.toFixed(1);
  total_cost = -1*total_cost.toFixed(3);
  average_cost = average_cost.toFixed(3);
  
  //Card data
  const count = [
    {
      title: "Unique Users",
      data: no_users,
      addition: "",
      icon: "/images/user-profile.png",
      color: "#FFD700"
    },
    {
      title: "Unique Sessions",
      data: no_sessions,
      addition: "",
      icon: "/images/session.png",
      color: "#FFD700"
    },
    {
      title: "Total Messages",
      data: total_messages,
      addition: "",
      icon: "/images/speech-bubble.png",
      color: "#FFD700"
    },
    {
      title: "Total Cost",
      data: total_cost,
      addition: "USD",
      icon: "/images/save-money.png",
      color: "#FFD700"
    },
    
  ];    

  const side_margin = '2%';
  const [collapsed, setCollapsed] = useState(false);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <>
    <div className="Dashboard-page">
      <Layout style={{ minHeight: '98vh'}}>
        <Sidebar location={location} />
      <Layout style={{ background: 'white'}}>
        <div className="layout-content" style={{ marginTop: '1%', marginRight: side_margin, marginLeft: side_margin }}>
        
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: "1%", marginTop: "-1%" }}>
          <Title style={{ marginRight: '5%' }}>Dashboard</Title>
          <Select
            id="contractSelect"
            value={selectedContract}
            onChange={(value, option) => handleDropdownChange(value, option.key)}
            style={{ width: 200, height: 50, fontSize: '30px'}}
            dropdownStyle={{ fontSize: '22px' }}
          >
            {contractOptions.map((option, index) => (
              <Select.Option key={index} value={option} style={{ fontSize: '14px' }}>
                {option}
              </Select.Option>
            ))}
          </Select>

        
        </div>

        <div style={{ display: 'flex', gap: '16px' }}>
          {count.map((item, index) => (
            <div key={index} style={{ flex: '1 1 calc(33.33% - 8px)' }}>
              <Card bordered={false} className="criclebox" style={{ width: '100%', height: '100%', backgroundColor: item.color }}>
                <Col xs={24} style={{ textAlign: 'center' }}>
                  <Row gutter={[16, 16]}>
                    <img
                      src={process.env.PUBLIC_URL + item.icon}
                      alt="Image Alt Text"
                      style={{ width: '50px', height: '50px', marginLeft: "10px", marginRight: '10px', marginTop: '20px' }}
                    />
                    <Title level={1} style={{ marginTop: '20px', marginRight: '25px', marginBottom: '5px' }}>
                      {item.data}
                    </Title>

                    <span style={{ fontSize: '13px', color: '#888888', marginTop: '43px', marginBottom: '5px', marginLeft: "-25px" }}>
                      {item.addition}
                    </span>
                  </Row>
                  <Row>
                    <span style={{ fontSize: '20px', color: '#888888' }}>{item.title}</span>
                  </Row>
                </Col>
              </Card>
            </div>
          ))}
        </div>
  

          {/* <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', width: '60%' }}>
              <Card bordered={false} className="criclebox h-full" style={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                <LineChart no_messages={no_messages} cost_map={cost_map} unique_num={unique_users_map} unique_sess={sessions_map}/>
              </Card>
          </div> */}

            {/* <Row className="rowgap-vbox" gutter={[6, 24]}>
            {count.map((c, index) => (
                <Col
                key={index}
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={6}
                className="mb-24"
                >
                <Card bordered={false} className="criclebox " style={{width: "100%" ,height: "100%", backgroundColor: c.color}}>
                    <div className="number">
                    <Row align="middle" justify="center">
                    <Col xs={24} style={{ textAlign: 'center'}}>
                        <Row gutter={[16, 16]}>
                        <img
                            src={process.env.PUBLIC_URL + c.icon}
                            alt="Image Alt Text"
                            style={{ width: '50px', height: '50px', marginRight: '10px', marginTop: "20px"}}
                        />
                        <Title level={1} style={{ marginTop: '20px' , margineRight: "25px", marginBottom: "5px"}}>
                            {c.data} 
                        </Title>
                        
                        <span style={{ fontSize: '13px', color: '#888888', marginTop: '43px', marginBottom: "5px" }}>{c.addition}</span>
                        </Row>
                        <Row>
                        <span style={{ fontSize: '20px', color: '#888888'}}>{c.title}</span>
                        </Row>
                    </Col>
                    </Row>
                    </div>
                </Card>
                </Col>
            ))} */}

            {/* <Col xs={24} sm={24} md={24} lg={6} xl={6} className="mb-24">
            <Card bordered={false} className="criclebox " style={{width: "350px" ,height: "150px", backgroundColor: "#FFFFFF"}}>
                <div className="number">

                <Row align="middle" justify="center">
                    <Col xs={50}>
                    <span style={{ fontSize: '30px' }}>Chat-Bot</span>
                    </Col>
                </Row>

                <Row align="middle" justify="center">
                  <Col xs={50}>
                    <Select
                      id="contractSelect"
                      value={selectedContract}
                      onChange={(value, option) => handleDropdownChange(value, option.key)}
                      style={{ width: 150, marginLeft: "8px" }}
                    >
                      {contractOptions.map((option, index) => (
                        <Select.Option key={index} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Row>

                </div>
            </Card>
            </Col> */}

                        

            {/* End of Single Card */}

            {/* Add some margin to create a gap */}
            <div style={{ margin: "20px 0" }}></div>
            
        <Row gutter={[16, 0]}>
            <Col xs={24} sm={24} md={14} lg={14} xl={14}>
            <Card bordered={false} className="criclebox h-full" style={{ width: "100%", alignItems: "left", backgroundColor: "#FFFFFF" }}>
                <Echart data={data} unique_num={unique_users_map} unique_sess={sessions_map} />
            </Card>
            </Col>

            <Col xs={24} sm={24} md={10} lg={10} xl={10}>
            <Card bordered={false} className="package-card" style={{ width: "100%", height: "400px", alignItems: "right" , backgroundColor: "#FFFFFF"}}>
                <DoughnutChart data = {data} />
            </Card>
            
            <div style={{marginTop: "16px"}}>
                <Card bordered={false} className="criclebox h-full" style={{width: "100%", backgroundColor: "#FFFFFF"}}>
                  <LineChart no_messages={no_messages} cost_map={cost_map} unique_num={unique_users_map} unique_sess={sessions_map}/>
                </Card>
            </div>
            
            </Col>
        </Row>
        </div>

      </Layout>
      </Layout>
      </div>
    </>
  );
}

export default App;

